

















































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import "@/assets/css/split.css";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import Moment from "moment-timezone";
import DataPushSet from './datapushset.vue'
import checkAuth from "@/lib/Common/checkauth";
import "@/assets/css/table.css";

class PageUserRequest extends PageRequest {
    keyword: string;
    areaId: number;
}

class DataPushSetDto {
    isAll: boolean;
    dataPushId: number;
    deviceId: any[] = [];
    operator: boolean;
}

@Component({
    components: { DataPushSet },
})
export default class DeviceDataPush extends AbpBase {

    pagerequest: PageUserRequest = new PageUserRequest();
    dataPushModalShow: boolean = false;
    splitnum: number = 0.15;
    searchName: string = ""; //树形搜索名称
    areaTree: any[] = [];
    areaTreeList: any[] = [];
    choosemeters: any[] = [];//选中的表计
    dataPushSetDto: DataPushSetDto = new DataPushSetDto();
    //检测按钮权限
    checkButtonAuth(tag: string) {
        return checkAuth.CheckButton(tag);
    }
    //推送设置
    deviceDataPush() {
        let val = (this.$refs.selection as any).getSelection();
        if (val.length == 0) {
            this.$Modal.info({
                title: this.L("Tips"),
                content: this.L("PleasChoose") + this.L("Meter"),
            });
            return;
        }
        this.choosemeters = [];
        val.forEach((ele) => {
            this.choosemeters.push(ele.id);
        });
        this.dataPushModalShow = true;
    }
    //取消
    async canceDataPush(meterId: string) {
        this.dataPushSetDto.deviceId = [];
        this.dataPushSetDto.deviceId.push(meterId);
        this.dataPushSetDto.isAll = false;
        this.dataPushSetDto.dataPushId = 0;
        let res = await this.$store
            .dispatch({
                type: "datapush/setDataPush",
                data: this.dataPushSetDto,
            })
            .catch((err) => {
                this.$Modal.info({
                    title: this.L("Tips"),
                    content: err,
                });
            });
        this.$Modal.info({
            title: this.L("Tips"),
            content: res,
        });
        await this.getpage();
    }
    //搜索树形结构
    searchTree(value: any, treeList) {
        if (!value) {
            this.areaTree = this.areaTreeList;
            return;
        }
        const rebuildData = (value, treeList) => {
            let newarr = [];
            treeList.forEach((element) => {
                if (element.children && element.children.length) {
                    if (element.title.indexOf(value) > -1) {
                        element.expand = true;
                        newarr.push(element);
                    }
                    const ab = rebuildData(value, element.children);
                    const obj = {
                        ...element,
                        expand: true,
                        children: ab,
                    };
                    if (ab && ab.length) {
                        newarr.push(obj);
                    }
                } else {
                    if (element.title.indexOf(value) > -1) {
                        newarr.push(element);
                    }
                }
            });
            return newarr;
        };
        this.areaTree = [];
        this.areaTree = rebuildData(value, this.areaTreeList);
    }
    get list() {
        return this.$store.state.devicedatapush.list;
    }
    //选择节点
    getAreaId() {
        let item = (this.$refs.tree as any).getSelectedNodes();
        if (item.length > 0) {
            this.pagerequest.areaId = item[0].id;
        }
        this.$store.commit("devicedatapush/setCurrentPage", 1);
        this.getpage();
    }
    pageChange(page: number) {
        this.$store.commit("devicedatapush/setCurrentPage", page);
        this.getpage();
    }
    pagesizeChange(pagesize: number) {
        this.$store.commit("devicedatapush/setPageSize", pagesize);
        this.getpage();
    }
    getSearch() {
        this.$store.commit("devicedatapush/setCurrentPage", 1);
        this.getpage();
    }
    async getpage() {
        this.pagerequest.maxResultCount = this.pageSize;
        this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
        await this.$store.dispatch({
            type: "devicedatapush/getAll",
            data: this.pagerequest,
        });
    }
    get pageSize() {
        return this.$store.state.devicedatapush.pageSize;
    }
    get totalCount() {
        return this.$store.state.devicedatapush.totalCount;
    }
    get currentPage() {
        return this.$store.state.devicedatapush.currentPage;
    }
    //区域
    async getAreaTree() {
        await this.$store
            .dispatch("area/getAreaLeftTree")
            .then((val) => {
                this.areaTree = val;
                this.areaTreeList = val;
            })
            .catch((err) => {
                console.log(err);
            });
    }
    get loading() {
        return this.$store.state.area.loading;
    }
    //获取上级名称
    getAreaName(areaId: number) {
        this.areaTreeList.forEach((ele) => {
            if (ele.id == areaId) {
                return ele.title;
            }
            if (ele.children != null && ele.children.length > 0) {
                this.getAreaName(areaId);
            }
        })
    }
    columns = [
        {
            type: "index",
            width: 80,
            align: "left",
            fixed: "left",
            title: this.L("IndexNo"),
        },
        {
            type: "selection",
            width: 60,
            align: "center",
            fixed: "left",
        },
        {
            title: this.L("DeviceNo"),
            key: "deviceNo",
            fixed: "left",
            width: 130,
            render: (h: any, params: any) => {
                return h("div", [
                    h(
                        "span",
                        {
                            style: {
                                display: "inline-block",
                                width: "100%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            },
                            domProps: { title: params.row.deviceNo },
                        },
                        params.row.deviceNo
                    ),
                ]);
            },
        },
        {
            title: this.L("RoomNo"),
            key: "roomNo",
            fixed: "left",
            width: 130,
            render: (h: any, params: any) => {
                return h("div", [
                    h(
                        "span",
                        {
                            style: {
                                display: "inline-block",
                                width: "100%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            },
                            domProps: { title: params.row.roomNo },
                        },
                        params.row.roomNo
                    ),
                ]);
            },
        },
        {
            title: this.L("Location"),
            key: "docation",
            width: 130,
            render: (h: any, params: any) => {
                return h("div", [
                    h(
                        "span",
                        {
                            style: {
                                display: "inline-block",
                                width: "100%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            },
                            domProps: { title: params.row.docation },
                        },
                        params.row.docation
                    ),
                ]);
            },
        },

        {
            title: this.L("Organizations"),
            key: "organizationName",
            width: 130,
            sortId: 5,
            render: (h: any, params: any) => {
                return h("div", [
                    h(
                        "span",
                        {
                            style: {
                                display: "inline-block",
                                width: "100%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            },
                            domProps: { title: params.row.organizationName },
                        },
                        params.row.organizationName
                    ),
                ]);
            },
        },
        {
            title: this.L("Areas"),
            key: "areaName",
            width: 160,
            sortable: true,
            sortId: 3,
            render: (h: any, params: any) => {
                return h("div", [
                    h(
                        "span",
                        {
                            style: {
                                display: "inline-block",
                                width: "100%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            },
                            domProps: { title: params.row.areaName },
                        },
                        params.row.areaName
                    ),
                ]);
            },
        },
        {
            title: this.L("DeviceState"),
            key: "deviceState",
            width: 130,
            render: (h: any, params: any) => {
                let str = this.L("OffLine");
                let id = params.row.lineState;
                if (id == 1) {
                    str = this.L("OnLine");
                }
                return h("span", str);
            },
        },
        {
            sortable: true,
            title: this.L("LastReadTime"),
            key: "lastReadTime",
            width: 150,
            resizable: true,
            align: "center",
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.lastReadTime == null
                        ? ""
                        : Moment(params.row.lastReadTime).format("YYYY-MM-DD HH:mm:ss")
                );
            },
        },
        {
            title: this.L("DataPush"),
            key: "dataPushName",
            width: 130,
            render: (h: any, params: any) => {
                return h("div", [
                    h(
                        "span",
                        {
                            style: {
                                display: "inline-block",
                                width: "100%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            },
                            domProps: { title: params.row.dataPushName },
                        },
                        params.row.dataPushName
                    ),
                ]);
            },
        },
        {
            title: this.L("PushUrl"),
            key: "url",
            width: 130,
            render: (h: any, params: any) => {
                return h("div", [
                    h(
                        "span",
                        {
                            style: {
                                display: "inline-block",
                                width: "100%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            },
                            domProps: { title: params.row.url },
                        },
                        params.row.url
                    ),
                ]);
            },
        },
        {
            title: this.L("ReadData"),
            key: "readData",
            width: 130,
            render: (h: any, params: any) => {
                let str = this.L("Unknown");
                if (params.row.readData) {
                    str = this.L("Started");
                } else {
                    str = this.L("NoStart");
                }
                return h("span", str);
            },
        },
        {
            title: this.L("MonitorData"),
            key: "monitorData",
            width: 130,
            render: (h: any, params: any) => {
                let str = this.L("Unknown");
                if (params.row.monitorData) {
                    str = this.L("Started");
                } else {
                    str = this.L("NoStart");
                }
                return h("span", str);
            },
        },
        {
            title: this.L("FreezeData"),
            key: "freezeData",
            width: 130,
            render: (h: any, params: any) => {
                let str = this.L("Unknown");
                if (params.row.freezeData) {
                    str = this.L("Started");
                } else {
                    str = this.L("NoStart");
                }
                return h("span", str);
            },
        },
        {
            title: this.L("PushUrl"),
            key: "url",
            width: 260,
            render: (h: any, params: any) => {
                return h("div", [
                    h(
                        "span",
                        {
                            style: {
                                display: "inline-block",
                                width: "100%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            },
                            domProps: { title: params.row.url },
                        },
                        params.row.url
                    ),
                ]);
            },
        },
        {
            title: "Id",
            key: "id",
            width: 130,
            render: (h: any, params: any) => {
                return h("div", [
                    h(
                        "span",
                        {
                            style: {
                                display: "inline-block",
                                width: "100%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            },
                            domProps: { title: params.row.id },
                        },
                        params.row.id
                    ),
                ]);
            },
        },
        {
            title: this.L("Actions"),
            key: "Actions",
            width: 90,
            fixed: "right",
            render: (h: any, params: any) => {
                let cancel = this.checkButtonAuth('devicedatapushcancel');
                return h("div", [
                    cancel ? h(
                        "Button",
                        {
                            props: {
                                type: "error",
                                size: "small",
                            },
                            on: {
                                click: async () => {
                                    await this.canceDataPush(params.row.id);
                                },
                            },
                        },
                        this.L("Cancel")
                    ) : '',
                ]);
            },
        },
    ];
    async created() {
        await this.getAreaTree();
        await this.getpage();
    }
}
